import axios from '@/utils/axios'

export function requestExchangeRate(currency) {
    return axios.get('/exchange/' + currency,  {})
}